import React, { useContext, useState } from 'react';
import MainModal from '../components/MainModal';
import { AppInfoContext } from '../../../../../App';
import ProblemDetails from './ProblemDetails';
import './ProblemManagementModal.css';
import WorkOrderForm from './workorder/WorkOrderForm';
import SubmitInfoMessage from './SubmitInfoMessage';
import WorkOrderDetails from './workorder/WorkOrderDetails';
import DeleteWorkOrder from './workorder/DeleteWorkOrder';
import CloseWorkOrder from './workorder/CloseWorkOrder';
import UploadFiles from './workorder/UploadFiles';
import ClosedWorkOrderDetails from './workorder/ClosedWorkOrderDetails';
import { useIsMobile } from '../reportproblem/ReportProblem';

function ProblemManagementModal() {
  const { appInformation, setAppInformation } = useContext(AppInfoContext);
  const [currentFormStep, setCurrentFormStep] = useState(
    appInformation.problemManagement.selectedOption
  );

  const [isMinimized, setIsMinimized] = useState(false);

  const isMobile = useIsMobile();

  const returnToMainMenu = () => {
    setAppInformation((prevValue) => {
      return {
        ...prevValue,
        problemManagement: {
          modalUpdate: 0,
          modalActive: false,
          selectedOption: 0,
          id: null,
          workOrderId: null,
          workOrderSerialNumber: null,
          locationModal: false,
          elementSelection: false,
          selectedLayer: null,
          selectedElement: null,
          location: null,
        },
      };
    });
  };

  const [formInfo, setFormInfo] = useState({
    workOrder: { formType: null, formSubmissionAccepted: false },
  });

  const increaseFormStep = () => {
    setCurrentFormStep((prevValue) => prevValue + 1);
  };

  const decreaseFormStep = () => {
    setCurrentFormStep((prevValue) => prevValue - 1);
  };

  const setFormStep = (newStep) => {
    setCurrentFormStep(newStep);
  };

  const mutualModalProps = {
    closeModal: returnToMainMenu,
    increaseFormStep: increaseFormStep,
    decreaseFormStep: decreaseFormStep,
    currentFormStep,
    setFormStep,
    formInfo,
    setFormInfo,
    isMinimized,
    setIsMinimized,
  };

  const modalOptions = {
    0: {
      title: 'Detalji kvara',
      component: ProblemDetails,
    },
    1: {
      title: 'Otvaranje radnog naloga',
      component: WorkOrderForm,
    },
    2: {
      title: 'Otvaranje radnog naloga',
      component: SubmitInfoMessage,
    },
    3: {
      title: 'Radni nalog',
      component: WorkOrderDetails,
    },
    4: {
      title: 'Poništavanje radnog naloga',
      component: DeleteWorkOrder,
    },
    5: {
      title: 'Zatvaranje radnog naloga',
      component: CloseWorkOrder,
    },
    6: {
      title: 'Učitavanje datoteka',
      component: UploadFiles,
    },
    7: {
      title: 'Zatvaranje radnog naloga',
      component: SubmitInfoMessage,
    },
    8: {
      title: 'Zatvoreni radni nalog',
      component: ClosedWorkOrderDetails,
    },
  };

  return (
    <div
      className={
        appInformation.problemManagement.locationModal ||
        [2, 4, 7].includes(currentFormStep)
          ? 'problem-report problem-report-confirmation'
          : 'problem-report'
      }
      style={{
        height:
          (isMinimized ||
            appInformation.problemManagement.locationModal ||
            appInformation.problemManagement.elementSelection) &&
          'auto',
        right:
          appInformation.statistics.problemModalActive &&
          !appInformation.statistics.statisticsMinimized
            ? '440px'
            : !isMobile
            ? '70px'
            : '',
      }}
    >
      <div className="problem-report-body ">
        {modalOptions[currentFormStep] && (
          <MainModal
            title={modalOptions[currentFormStep].title}
            component={modalOptions[currentFormStep].component}
            {...mutualModalProps}
          />
        )}
      </div>
    </div>
  );
}

export default ProblemManagementModal;
